__turbopack_context__.v({
  "component": "XPGotG_component",
});
